import {
  Box,
  Button,
  FooterActionBar,
  ModalIsland,
  Typography,
} from "@saviynt/design-system";
import { FormattedMessage, useIntl } from "react-intl";

function SuccessIllustration() {
  return (
    <svg
      viewBox="0 0 480 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="block h-full w-full"
      preserveAspectRatio="xMidYMid slice"
      aria-hidden
    >
      <rect width="480" height="200" rx="4" fill="white" />
      <path
        d="M4.23855e-07 106C17.3191 99.0714 65.9121 94.1805 127.446 94.1805C188.98 94.1805 281.125 102.638 336.184 106C391.242 109.362 442.061 106 480 99.0713V0H4.23855e-07C4.23855e-07 0 -5.29819e-07 91.2117 4.23855e-07 106Z"
        fill="#E5F7E0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M202.5 98C202.5 77.2893 219.289 60.5 240 60.5C260.711 60.5 277.5 77.2893 277.5 98C277.5 118.711 260.711 135.5 240 135.5C219.289 135.5 202.5 118.711 202.5 98ZM258.744 87.6879C259.558 86.8743 259.558 85.5552 258.744 84.7416C257.931 83.928 256.611 83.9281 255.798 84.7417L233.701 106.839L224.202 97.3404C223.389 96.5268 222.07 96.5268 221.256 97.3404C220.442 98.154 220.442 99.4731 221.256 100.287L232.228 111.259C232.619 111.649 233.149 111.869 233.701 111.869C234.254 111.869 234.784 111.649 235.174 111.259L258.744 87.6879Z"
        fill="#027E27"
      />
    </svg>
  );
}

type CreateUserSuccessModalProps = {
  isOpen: boolean;
  email: string;
  onDone: () => void;
};

export default function CreateUserSuccessModal({
  isOpen,
  email,
  onDone,
}: CreateUserSuccessModalProps) {
  const intl = useIntl();

  return (
    <ModalIsland
      isOpen={isOpen}
      onClose={onDone}
      title={intl.formatMessage({
        id: "Flcow+",
        defaultMessage: "User created successfully",
        description: "Success modal title after creating a user",
      })}
      classNames={{
        bodyClassName: "!p-0",
      }}
      contentBody={
        <Box className="flex w-full min-w-0 flex-1 flex-col gap-4 self-stretch sm:gap-5 relative">
          <Box className="relative -mx-12 w-[calc(100%+6rem)] min-w-0 shrink-0 overflow-hidden rounded-t-sm">
            <SuccessIllustration />
          </Box>
          <Box className="flex w-full min-w-0 flex-col gap-2 text-center absolute bottom-1 pb-4">
            <Typography
              kind="body1"
              color="--color-foreground-primary-bold"
              desktop="body1-d"
              className="dark:!text-black dark:!mb-4"
            >
              <FormattedMessage
                id="bR3C7i"
                defaultMessage="Login credentials have been sent to their email: {email}"
                description="Login credentials have been sent to their email"
                values={{ email }}
              />
            </Typography>
          </Box>
        </Box>
      }
      FooterActionBarComp={
        <FooterActionBar size="large">
          <Box className="flex w-full justify-end">
            <Button kind="filled" size="medium" onClick={onDone}>
              <FormattedMessage
                id="fq4IPE"
                defaultMessage="Done"
                description="Done"
              />
            </Button>
          </Box>
        </FooterActionBar>
      }
    />
  );
}
